import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { ConsultancyService } from '../dashboard/services/consultancy.service';
import { catchError, EMPTY } from 'rxjs';

export const consultancyResolver: ResolveFn<any> = (route, state) => {
  const service = inject(ConsultancyService);
  const router = inject(Router);
  
  const slug = route.paramMap.get('slug');
  return service.getConsultancyBySlug(slug!).pipe(
    catchError((error) => {
      console.error('Resolver error:', error);

      // Redirect to 404 page
      router.navigate(['/not-found']);

      return EMPTY;
    })
  );
};
